<template>
	<div class="tooltop-zone">
		<div class="state-taxcode">NNT ngừng hoạt động và đã đóng MST</div>
		<div class="line-tooltip">Ngày ngừng hoạt động: {{dataTooltips.closedDate ? $ms.commonFn.getMoment(new Date(dataTooltips.closedDate)).format('DD/MM/YYYY hh:mm') : ''}}</div>
		<div class="line-tooltip">Cập nhật lần cuối: 
			{{
				dataModifiedDate ? 
					$ms.commonFn.getMoment(new Date(dataModifiedDate)).format('DD/MM/YYYY hh:mm') 
					: 
					(dataTooltips.modifiedDate ? 
						$ms.commonFn.getMoment(new Date(dataTooltips.modifiedDate)).format('DD/MM/YYYY hh:mm') 
						: '')
			}} <div class="has-link ml-1" @click="reloadModifiedDate(dataTooltips.taxCode)"><span :class="[isRotate ? 'rotate' : '','icon24']"></span> Tải lại</div> </div>
		<div class="line-tooltip">Xem thông tin trên website Tổng cục Thuế <a class="has-link ml-1" target="_blank" :href="linkHelp($ms.constant.Help.GeneralDepartmentTax)">Tại đây</a></div>
	</div>
</template>
<script>
import {ref, getCurrentInstance, computed} from 'vue';
import integrationBIApi from '@/apis/integration/integrationBusinessInformationApi.js';
import {ModuleTARiskCustomerVendor} from '@/stores/moduleConst'; 

export default {
  components: {},
	props:{
		dataTooltip:{}, // dữ liệu của hàng
	},
  name: 'TARiskCustomerVendorInfoPopup',
  setup: props => {

    const {proxy} = getCurrentInstance();
		const dataTooltips = computed(() => {
			return props.dataTooltip;
		});
		const dataModifiedDate = ref();
    const module = ModuleTARiskCustomerVendor;
		const isRotate = ref(false)
		/**
		 * Gắn link help Tổng cục thuế
		 * TPNAM 02.01.2024
		 */
		function linkHelp(code, type) {
			type = type || 'mimosa';
			return window._misaHelp[code];
		};
		async function reloadModifiedDate(code){
			isRotate.value = true;
			try {
				await integrationBIApi
        .getBusinessInformationLookUp(code.replace('-', '').replace(' ', ''), true)
        .then(res => {
					dataModifiedDate.value = res.modifiedDate
        });
				isRotate.value = false;
			} catch (error) {
				
			}
			finally{
				isRotate.value = false;
			}
			
		}
		return {
			dataTooltips,
			linkHelp,
			reloadModifiedDate,
			integrationBIApi,
			dataModifiedDate,
			module,
			ModuleTARiskCustomerVendor,
			isRotate
		};

  },
};
</script>
<style lang="scss">
	.tooltop-zone {
		background: #050C24;
		color: $white;
		padding: 7px 10px;
		.line-tooltip {
			display: flex;
			align-items: center;
		}
		.state-taxcode{
			color: $required;
		}
		.has-link{
			color: #0078d7;
			cursor: pointer;
			display: flex;
			align-items: center;
		}
		.icon24{
			width: 24px;
			height: 24px;
			position: relative;
			&::before{
				background-position: -265px -456px;
			}
			&.rotate{
				animation: rotateReload 2s linear infinite;
			}
		}
	}
	@keyframes rotateReload {
		0%{
			transform: rotate(0deg);
		}
		100%{
			transform: rotate(360deg);
		}
	}
</style>
